import React from 'react';
import { Navigate } from 'react-router';
import Base from '../Base';
import Ordering from "./Ordering";
import { Header } from '../Header';
import { Footer } from '../Footer';
import SelectAsync from 'react-select/async';
import { NavLink } from 'react-router-dom';

export default class Orderings extends Base {
    constructor(props) {
        super(props);
        this.state = {
            caller: props.Caller,
            department: props.Department,
            type: props.Type,
            inline: this.isNull(props.Inline) ? false : props.Inline,
            controllerName: 'ordering',
            IsV2: true,
            data: null,
            page: 1,
            per_page: 30,
            phrase: '',
            loading: true,
            systemModuleId: 0,
            moduleAccessStatus: 1,
        };

        this.state.filters = {
            personId: this.isNull(props.PersonId) ? this.getDefaultGuid() : props.PersonId,
            department: this.state.department,
            type: this.state.type,
            parentId: this.isNull(props.ParentId) ? this.getDefaultGuid() : props.ParentId,
            personMobile: '',
            personName: '',
            status: -1,
            description: '',
            marketerName: '',
        }
        this.setModuleId();
        this.keyDownFunction = this.keyDownFunction.bind(this);
    }
    componentWillUnmount() {
        this.removeKeyDown();
    }
    componentWillReceiveProps(props) {
        if (this.state.department === props.Department && this.state.type === props.Type) return;
        this.state.department = props.Department;
        this.state.type = props.Type;
        this.state.filters.department = this.state.department;
        this.state.filters.type = this.state.type;
        this.state.filters.parentId = this.isNull(props.ParentId) ? this.getDefaultGuid() : props.ParentId;

        this.state.filters.personMobile = '';
        this.state.filters.personName = '';
        this.state.filters.description = '';
        this.state.filters.status = -1;
        this.state.filters.marketerName = '';

        this.setModuleId();

        if (this.state.type === 3)
            this.getUiSettingConfigs({ formName: 'orderings_type3' });
        this.refreshData();
    }
    setModuleId() {
        if (this.state.filters.type === 1 || this.state.filters.type === 2 || this.state.filters.type === 4 || this.state.filters.type === 8)
            this.state.systemModuleId = 9;
        if (this.state.filters.type === 3 || this.state.filters.type === 6 || this.state.filters.type === 7)
            this.state.systemModuleId = 35;
        if (this.state.filters.type === 5)
            this.state.systemModuleId = 35;
    }
    componentDidMount() {
        this.httpPost("api/v1/common/check/module/access", {
            systemModuleId: this.state.systemModuleId
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                this.state.moduleAccessStatus = data.status;
                if (this.state.type === 3)
                    this.getUiSettingConfigs({ formName: 'orderings_type3' });
                this.refreshData();
            });
    }
    getSource() {
        if (this.state.department === 'crm') return 1;
        if (this.state.department === 'production_planing' || this.state.department === 'production_orders') return 2;
        return 0;
    }
    onEdit(id) {
        this.removeKeyDown();
        this.showComponents({ component: <Ordering Type={this.state.type} SourceId={this.getSource()} Caller={this} Id={id} /> });
    }
    onAdd() {
        this.removeKeyDown();
        this.showComponents({ component: <Ordering Type={this.state.type} ParentId={this.state.filters.parentId} SourceId={this.getSource()} Caller={this} /> });
    }
    changeMode(mode) {
        this.state.filters.mode = mode;
        this.refreshData();
    }
    getCaption() {
        if (this.state.type === 1) return 'سفارش';
        if (this.state.type === 2) return 'پیش فاکتور';
        if (this.state.type === 3) {
            if (this.state.department === 'production_orders') return 'سفارش تولید';
            if (this.state.department === 'production_planing') return 'برنامه ریزی تولید';
            return 'سفارش تولید';
        }
        if (this.state.type === 4) return 'سفارش خرید';
        if (this.state.type === 5) return 'برآورد سفارش';
        if (this.state.type === 6) return 'پردازش تولید';
        if (this.state.type === 7) return 'تولید محصولی-مرحله ای';
        if (this.state.type === 8) return 'سفارش خارجی';
        return '';
    }
    getCaptions() {
        if (this.state.type === 1) return 'سفارشات';
        if (this.state.type === 2) return 'پیش فاکتورها';
        if (this.state.type === 3) {
            if (this.state.department === 'production_orders') return 'سفارشات تولید';
            if (this.state.department === 'production_planing') return 'برنامه ریزی تولیدات';
            return 'سفارشات تولید';
        }
        if (this.state.type === 4) return 'سفارشات خرید';
        if (this.state.type === 5) return 'برآورد سفارشات';
        if (this.state.type === 6) return 'پردازش تولیدات';
        if (this.state.type === 7) return 'تولیدات محصولی-مرحله ای';
        if (this.state.type === 8) return 'سفارشات خارجی';
        return '';
    }
    renderForm() {
        //if (!this.hasPermission(this.state.menuId)) return this.renderPermissionDenied();
        if (this.state.moduleAccessStatus <= 0) return this.renderSystemModuleModuleAccessMessage(this.state.moduleAccessStatus);

        return <div>
            <div className="nk-content-body">
                <div className="nk-block-head nk-block-head-sm">
                    <div className="nk-block-between">
                        {!this.state.inline && <div className="nk-block-head-content">
                            <h3 className="nk-block-title page-title">فهرست {this.getCaptions()}</h3>
                            <div className="nk-block-des text-soft">
                                <p>{this.money(this.state.data.recordsCount)} {this.getCaption()} یافت شد</p>
                            </div>
                        </div>}
                        <div className="nk-block-head-content">
                            <div className="toggle-wrap nk-block-tools-toggle">
                                <a href="#" className="btn btn-icon btn-trigger toggle-expand me-n1" data-target="pageMenu"><em className="icon ni ni-menu-alt-r"></em></a>
                                <div className="toggle-expand-content" data-content="pageMenu">
                                    <ul className="nk-block-tools g-3">
                                        <li>
                                            {(this.state.type === 4 || this.state.department === 'production_orders' || this.state.department === 'crm' || this.state.department === '') && <a className="hand btn btn-primary" onClick={e => this.onAdd()}><em className="icon ni ni-plus"></em>
                                                <span>ثبت {this.getCaption()} جدید</span>
                                            </a>}
                                        </li>
                                        <li>
                                            <a onClick={e => this.refreshData(e, "list", "excel")} className="hand btn btn-success"><span>دانلود اکسل</span></a>
                                        </li>
                                        {(this.state.type === 8 || this.state.type === 4) && <li>
                                            <NavLink to="/buycontracttypes/" className="hand btn btn-blue">انواع قراردادهای خرید</NavLink>
                                        </li>}
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {this.renderView()}
            </div>
        </div>
    }
    renderView() {
        return <div className="nk-block">
            <div className="card card-bordered card-stretch">
                <div className="card-inner-group">
                    <div className="card-inner position-relative card-tools-toggle">
                        <div className="card-title-group">
                            <form className="card-tools" mthod="post" onSubmit={e => this.refreshData(e)}>
                                <div className="form-inline flex-nowrap gx-3">
                                    <div className="form-wrap">
                                        <input type="text" defaultValue={this.state.phrase} onChange={e => this.state.phrase = e.target.value} placeholder={"شماره " + this.getCaptions()} className="form-control" />
                                    </div>
                                    {this.state.type !== 6 && this.state.type !== 4 && this.state.type !== 8 &&  this.state.type !== 7 && <div className="form-wrap">
                                        <input type="text" defaultValue={this.state.filters.personName} onChange={e => this.state.filters.personName = e.target.value} placeholder="نام مشتری" className="form-control" />
                                    </div>}
                                    {this.state.type !== 6 && this.state.type !== 4 && this.state.type !== 8 &&  this.state.type !== 7 && <div className="form-wrap">
                                        <input type="text" defaultValue={this.state.filters.personMobile} onChange={e => this.state.filters.personMobile = e.target.value} placeholder="شماره موبایل مشتری" className="form-control" />
                                    </div>}
                                    {this.state.type === 2 && <div className="form-wrap">
                                        <input type="text" defaultValue={this.state.filters.marketerName} onChange={e => this.state.filters.marketerName = e.target.value} placeholder="نام بازاریاب" className="form-control" />
                                    </div>}
                                    {this.state.type === 1 && <div className="form-wrap">
                                        <SelectAsync
                                            isMulti={false}
                                            placeholder="انتخاب سفارش تولید"
                                            defaultOptions
                                            loadOptions={(inputValue, callback) => this.loadOrderingsOptions(inputValue, callback, 3)}
                                            onChange={e => this.state.filters.parentId = e.value}
                                        />
                                    </div>}
                                    {this.state.type === 3 &&
                                        <div className="form-wrap">
                                            <select defaultValue={this.state.filters.status} onChange={e => this.state.filters.status = parseInt(e.target.value)} className="form-control">
                                                <option value="-1">تمامی وضعیتها</option>
                                                <option value="6">در حال برنامه ریزی</option>
                                                <option value="1">در حال تولید</option>
                                                <option value="2">تکمیل شده</option>
                                                <option value="3">لغو شده</option>
                                            </select>
                                        </div>
                                    }
                                    <div className="form-wrap">
                                        <input
                                            defaultValue={this.state.filters.description}
                                            onChange={(e) => this.state.filters.description = e.target.value}
                                            type="text"
                                            className="form-control"
                                            placeholder="توضیحات"
                                        />
                                    </div>
                                    <div className="btn-wrap">
                                        <span className="d-none d-md-block"><button onClick={e => this.refreshData(e)} type="submit" className="btn btn-dim btn-outline-light hand"><em class="icon ni ni-search"></em> جستجو</button></span>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                    {this.state.data.recordsCount <= 0 ?
                        <div className="card-inner-group">
                            <div className="example-alert">
                                <div className="alert alert-pro alert-warning">
                                    <div className="alert-text">
                                        <h6>توجه</h6>
                                        <p>هیچ {this.getCaptions()}ی یافت نشد</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        :
                        <div className="card-inner p-0">
                            <div className="nk-tb-list nk-tb-ulist">
                                <div className="nk-tb-item nk-tb-head">
                                    <div className="nk-tb-col text-center"><span className="sub-text">شماره</span></div>
                                    {(this.state.type === 5) && <div className="nk-tb-col text-center"><span className="sub-text">عنوان</span></div>}
                                    {((this.state.type !== 6 && this.state.type !== 4 && this.state.type !== 8 &&  this.state.type !== 3 && this.state.type !== 7) || (this.state.type === 3 && this.state.data.global.company.mainBussinessType !== 3)) && <div className="nk-tb-col text-center"><span className="sub-text">نام مشتری</span></div>}
                                    {((this.state.type !== 6 && this.state.type !== 4 && this.state.type !== 8 &&  this.state.type !== 3 && this.state.type !== 7) || (this.state.type === 3 && this.state.data.global.company.mainBussinessType !== 3)) && <div className="nk-tb-col text-center"><span className="sub-text">موبایل مشتری</span></div>}
                                    {this.state.type === 2 && <div className="nk-tb-col text-center"><span className="sub-text">نام بازاریاب</span></div>}
                                    {this.state.type === 3 && this.state.data.global.company.mainBussinessType === 3 && <div className="nk-tb-col text-center"><span className="sub-text">خط تولید</span></div>}
                                    {this.state.type === 1 && this.state.data.global.company.mainBussinessType === 3 && <div className="nk-tb-col text-center"><span className="sub-text">سفارش تولید</span></div>}
                                    <div className="nk-tb-col text-center"><span className="sub-text">تاریخ</span></div>
                                    {this.state.type !== 6 && this.state.type !== 5 && <div className="nk-tb-col text-center"><span className="sub-text">وضعیت</span></div>}
                                    <div className="nk-tb-col text-center"><span className="sub-text">مرحله</span></div>
                                    {this.state.type === 2 && <div className="nk-tb-col text-center"><span className="sub-text">مبلغ کل</span></div>}
                                    {this.state.type === 5 && <div className="nk-tb-col text-center"><span className="sub-text">مبلغ برآورد</span></div>}
                                    <div className="nk-tb-col text-center"><span className="sub-text">توضیحات</span></div>
                                    <div className="nk-tb-col text-end"><span className="sub-text">عملیات</span></div>
                                </div>
                                {this.state.data.records.map((record, index) =>
                                    <div className="nk-tb-item">
                                        <div className="nk-tb-col">
                                            <span className="sub-text text-center">
                                                <a className="text-primary txt-bold hand" onClick={e => this.onEdit(record.id)} title="مشاهده و ویرایش">
                                                    {record.fullNumber}
                                                </a>
                                            </span>
                                        </div>
                                        {this.state.type === 5 &&
                                            <div className="nk-tb-col">
                                                <span className="sub-text text-center">{record.title}</span>
                                            </div>
                                        }
                                        {((this.state.type !== 6 && this.state.type !== 4 && this.state.type !== 8 &&  this.state.type !== 3 && this.state.type !== 7) || (this.state.type === 3 && this.state.data.global.company.mainBussinessType !== 3)) && <div className="nk-tb-col">
                                            <span className="sub-text text-center">{record.personName}</span>
                                        </div>}
                                        {((this.state.type !== 6 && this.state.type !== 4 && this.state.type !== 8 &&  this.state.type !== 3 && this.state.type !== 7) || (this.state.type === 3 && this.state.data.global.company.mainBussinessType !== 3)) && <div className="nk-tb-col">
                                            <span className="sub-text text-center">{record.personMobile}</span>
                                        </div>}
                                        {this.state.type === 2 && <div className="nk-tb-col">
                                            <span className="sub-text text-center">{record.marketerName}</span>
                                        </div>}
                                        {this.state.type === 3 && this.state.data.global.company.mainBussinessType === 3 && <div className="nk-tb-col">
                                            <span className="sub-text text-center">{record.productionLines.map(item => <span style={{ "background-color": "#f8a602", "border-radius": "4px", "padding": "2px", "margin": "0 2px", "display": "inline-block" }} >{item.label}</span>)}</span>
                                        </div>}
                                        {this.state.type === 1 && this.state.data.global.company.mainBussinessType === 3 && <div className="nk-tb-col">
                                            <span className="sub-text text-center">
                                                {record.parentFullNumber}
                                                {record.parentProductionLines.map(item => <span style={{ "background-color": "#f8a602", "border-radius": "4px", "padding": "2px", "margin": "0 2px", "display": "inline-block" }} >{item.label}</span>)}
                                            </span>
                                        </div>}
                                        <div className="nk-tb-col">
                                            <span className="sub-text text-center">{record.dateString}</span>
                                        </div>
                                        {this.state.type !== 6 && this.state.type !== 5 && <div className="nk-tb-col">
                                            <span className="sub-text text-center">{record.statusString}</span>
                                        </div>}
                                        <div className="nk-tb-col">
                                            <span className="onlyMobile">مرحله: </span>
                                            <span className="sub-text text-center">{record.workFlowStepName}</span>
                                        </div>
                                        {this.state.type === 2 &&
                                            <div className="nk-tb-col">
                                                <span className="sub-text text-center">{this.money(record.total)}</span>
                                            </div>
                                        }
                                        {this.state.type === 5 &&
                                            <div className="nk-tb-col">
                                                <span className="sub-text text-center">{this.money(record.total)}</span>
                                            </div>
                                        }
                                        <div className="nk-tb-col">
                                            <span className="sub-text text-center">{record.description}</span>
                                        </div>
                                        <div className="nk-tb-col text-end">
                                            <a className="hand text-danger mx-1" onClick={e => this.confirmRemove(record.id)} data-bs-toggle="modal" data-bs-target="#modalConfirmRemove" title="حذف">
                                                <em className="icon ni ni-cross-fill-c"></em>
                                            </a>
                                            <a className="hand text-primary mx-1" onClick={e => this.onEdit(record.id)} title="ویرایش">
                                                <em className="icon ni ni-pen"></em>
                                            </a>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    }
                    {this.createPaging()}
                </div>
            </div>
        </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.getGlobalContainer(),
                this.isEmpty(this.state.data.global.companies) ? [
                    <Header data={this.state.data} />,
                    <div className="nk-content ">
                        <div className="container-fluid">
                            <div className="nk-content-inner">
                                {this.renderNoCompanyRegister()}
                            </div>
                        </div>
                    </div>,
                ] :
                    this.state.inline ? this.renderView() :
                        [
                            <Header data={this.state.data} />,
                            <div className="nk-content ">
                                <div className="container-fluid">
                                    <div className="nk-content-inner">
                                        {this.renderForm()}
                                    </div>
                                </div>
                            </div>,
                            <Footer />,
                        ]
                ,
                this.renderPopupComponent(),
            ];

        return contents;
    }
}